<main #mainElement class="w-full">
  <lbca-input-text
    [maskInput]="'DATE_BR'"
    [tabeled]="isTabeled"
    [labeled]="!isLabeled"
    [editable]="isEditable"
    [disabled]="isDisabled"
    [require]="isRequired"
    [helperText]="helperTextValue"
    [label]="labelValue"
    [iconRight]="icon"
    (changeValue)="change($event)"
    (click)="click()"
    [hasExternalError]="hasError"
    [value]="valueInput"
    autocomplete="off"
  ></lbca-input-text>
</main>

<ng-template cdkPortal #templateAppend="cdkPortal">
  @if (!isLabeled || (isLabeled && isEditable)) {
    <div
      (click)="clickedInside = true"
      (mousedown)="eventBlockFocusOut($event)"
      class="datepicker-template"
      [ngClass]="helperTextValue && helperTextValue !== '' ? 'mt-[18px]' : 'mt-[12px]'"
    >
      <div
        class="dpt-arrow"
        [class.ponter-bottom]="position === 'top'"
        [class.ponter-top]="position === 'bottom'"
      ></div>
      <section class="dpt-header">
        <div class="dpt-base-date">
          <div (click)="changeTypeSelection()" class="dpt-base-date-button">
            @if (typeSelection === 'calendar') {
              {{ baseDate }}
            }
            @if (typeSelection === 'year') {
              {{ intervalYears }}
            }
            @if (typeSelection === 'month') {
              {{ baseYear }}
            }
            <lbca-icon name="lucide:chevron-down" />
          </div>
        </div>
        <div class="dpt-base-butons">
          <lbca-button
            title="Mês anterior"
            variant="unstyled"
            size="small"
            icon
            (click)="changePeriod('previus')"
          >
            <lbca-icon name="lucide:chevron-up" />
          </lbca-button>
          <lbca-button
            title="Próximo Mês"
            variant="unstyled"
            size="small"
            icon
            (click)="changePeriod('next')"
          >
            <lbca-icon name="lucide:chevron-down" />
          </lbca-button>
        </div>
      </section>
      @if (typeSelection === 'calendar') {
        <section class="dpt-calendar">
          <div class="dpt-week-labels">
            @for (weekDay of weekDays; track weekDay) {
              <div
                class="dpt-week-day"
                [class.dpt-week-zone-header]="getDayMathSelect(weekDay.index)"
              >
                {{ weekDay.label }}
              </div>
            }
          </div>
          <div class="dpt-week-struct">
            @for (week of calendar; track week) {
              <div class="dpt-week-row">
                @for (day of week.days; track day) {
                  <div
                    [class.dpt-week-zone]="getDayMathSelect(day)"
                    [class.dpt-day-not-month]="!getDayMathMonth(day)"
                    (mouseenter)="weekSelect = day"
                    (mouseleave)="weekSelect = null"
                    class="dpt-day-round"
                    (click)="selectDay(day)"
                  >
                    <div [class]="day.month() === baseMonth ? 'dpt-day' : 'dpt-day-month'">
                      <span
                        [class.dOff]="day | checkDateRules: rules : disabledDateRules : pipeArgs"
                      >
                        {{ day.format('DD') }}
                      </span>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </section>
      }
      @if (typeSelection === 'month') {
        <section class="dpt-month-table">
          @for (month of yearMonths; track month) {
            <div class="dpt-month-cell">
              <div (click)="selectMonth(month.index)" class="dpt-month-cell-button">
                {{ month.label }}
              </div>
            </div>
          }
        </section>
      }
      @if (typeSelection === 'year') {
        <section class="dpt-month-table">
          @for (year of years; track year) {
            <div class="dpt-month-cell">
              <div (click)="selectYear(year.index)" class="dpt-month-cell-button">
                {{ year.label }}
              </div>
            </div>
          }
        </section>
      }
    </div>
  }
</ng-template>
